/* FURRMACY · product page, cart drawer and cart page */
(function () {
  'use strict';
  var DRAWER_ID = 'fm-cart-drawer';

  function fmt(cents) {
    var n = cents / 100;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return 'AED ' + s;
  }
  function drawer() { return document.querySelector('[data-fm-cart-drawer]'); }
  function cartPage() { return document.querySelector('[data-fm-cart-page]'); }
  function rootUrl() { var d = drawer(); return (d && d.dataset.rootUrl) || '/'; }
  function cartUrl() { var d = drawer(); return (d && d.dataset.cartUrl) || '/cart'; }
  function api(path) { return rootUrl().replace(/\/$/, '') + path; }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function setCount(count) {
    document.querySelectorAll('.fm-cart-count').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.fm-header a[href="' + cartUrl() + '"]').forEach(function (a) {
      if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function sectionIds() {
    var ids = [DRAWER_ID];
    var page = cartPage();
    if (page) ids.push(page.dataset.sectionId);
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    var d = drawer();
    if (d && sections[DRAWER_ID]) {
      var doc = parse(sections[DRAWER_ID]);
      var fresh = doc.querySelector('[data-fm-cart-inner]');
      var inner = d.querySelector('[data-fm-cart-inner]');
      if (fresh && inner) inner.innerHTML = fresh.innerHTML;
      var c = d.querySelector('[data-fm-cart-item-count]');
      if (c) setCount(parseInt(c.getAttribute('data-fm-cart-item-count'), 10) || 0);
    }
    var page = cartPage();
    if (page && sections[page.dataset.sectionId]) {
      var pdoc = parse(sections[page.dataset.sectionId]);
      var pfresh = pdoc.querySelector('[data-fm-cart-page-inner]');
      var pinner = page.querySelector('[data-fm-cart-page-inner]');
      if (pfresh && pinner) pinner.innerHTML = pfresh.innerHTML;
    }
  }

  /* ---------- drawer open / close with focus trap ---------- */
  var lastFocus = null;
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
    var panel = d.querySelector('.fm-cdrawer__panel');
    setTimeout(function () { var b = d.querySelector('[data-fm-cart-close].fm-cdrawer__close'); (b || panel).focus(); }, 60);
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-fm-cart-close]');
    if (close) { e.preventDefault(); closeDrawer(); return; }
    var link = e.target.closest('.fm-header a[href="' + cartUrl() + '"], .fm-drawer a[href="' + cartUrl() + '"]');
    if (link && drawer() && !cartPage() && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      var menu = document.querySelector('[data-fm-drawer].is-open [data-fm-drawer-close]');
      if (menu) menu.click();
      openDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    var d = drawer(); if (!d || d.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = d.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- line quantity changes (drawer + cart page) ---------- */
  var busy = false;
  function changeLine(line, qty, container) {
    if (busy) return;
    busy = true;
    if (container) container.setAttribute('aria-busy', 'true');
    fetch(api('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.sections) renderSections(data.sections);
      if (data && typeof data.item_count === 'number') setCount(data.item_count);
    }).catch(function () { window.location.href = cartUrl(); })
      .finally(function () { busy = false; if (container) container.removeAttribute('aria-busy'); });
  }
  function lineScope(el) { return el.closest('[data-fm-cart-drawer] .fm-cdrawer__panel') || el.closest('[data-fm-cart-page]'); }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-fm-line-step]');
    if (step) {
      var li = step.closest('[data-fm-line]'); if (!li) return;
      var input = li.querySelector('[data-fm-line-input]');
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-fm-line-step'), 10));
      input.value = q;
      changeLine(parseInt(li.getAttribute('data-fm-line'), 10), q, lineScope(li));
      return;
    }
    var rm = e.target.closest('[data-fm-line-remove]');
    if (rm) {
      e.preventDefault();
      var rli = rm.closest('[data-fm-line]');
      changeLine(parseInt(rli.getAttribute('data-fm-line'), 10), 0, lineScope(rli));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-fm-line-input]');
    if (input) {
      var li = input.closest('[data-fm-line]');
      changeLine(parseInt(li.getAttribute('data-fm-line'), 10), Math.max(0, parseInt(input.value, 10) || 0), lineScope(li));
      return;
    }
    var note = e.target.closest('[data-fm-cart-note]');
    if (note) {
      fetch(api('/cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-fm-line-input]')) { e.preventDefault(); e.target.blur(); }
  });

  /* ---------- product page ---------- */
  function initProduct(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var variantsEl = root.querySelector('[data-fm-variants]');
    if (!form || root.dataset.fmBound) return;
    root.dataset.fmBound = '1';
    var variants = []; try { variants = JSON.parse(variantsEl.textContent); } catch (err) {}
    var idInput = form.querySelector('[data-fm-variant-id]');
    var atcs = root.querySelectorAll('[data-fm-atc]');
    var labelAdd = (root.querySelector('[data-fm-atc-label]') || {}).textContent || 'Add to cart';
    var soldText = 'Sold out';
    var err = root.querySelector('[data-fm-atc-error]');

    /* gallery */
    var track = root.querySelector('[data-fm-gallery-track]');
    var thumbs = root.querySelectorAll('[data-fm-gallery-thumb]');
    var idxEl = root.querySelector('[data-fm-gallery-index]');
    function current() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    function go(i) {
      if (!track) return;
      var n = track.children.length; i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = current();
      if (idxEl) idxEl.textContent = i + 1;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-fm-gallery-thumb'), 10)); }); });
      var prev = root.querySelector('[data-fm-gallery-prev]'); if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      var next = root.querySelector('[data-fm-gallery-next]'); if (next) next.addEventListener('click', function () { go(current() + 1); });
    }

    /* quantity */
    root.querySelectorAll('[data-fm-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-fm-qty-step'), 10));
      });
    });

    /* variants */
    var fieldsets = root.querySelectorAll('[data-fm-option]');
    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function updateVariant() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('.fm-pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var ok = variants.some(function (x) { return x.available && x.options[i] === val && x.options.every(function (o, j) { return j === i || o === opts[j]; }); });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
      atcs.forEach(function (b) {
        b.disabled = !v || !v.available;
        var l = b.querySelector('[data-fm-atc-label]'); if (l) l.textContent = v && v.available ? labelAdd : soldText;
      });
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-fm-price-now]').forEach(function (p) { p.textContent = fmt(v.price); });
      var was = root.querySelector('[data-fm-price-was]');
      if (was) { if (v.compare_at_price && v.compare_at_price > v.price) { was.hidden = false; was.textContent = fmt(v.compare_at_price); } else { was.hidden = true; } }
      if (v.featured_media && track) {
        var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) go(Array.prototype.indexOf.call(track.children, slide));
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', updateVariant); });
    if (fieldsets.length) updateVariant();

    /* add to cart */
    form.addEventListener('submit', function (e) {
      if (!drawer()) return;
      e.preventDefault();
      if (err) err.hidden = true;
      atcs.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var fd = new FormData(form);
      fd.append('sections', DRAWER_ID);
      fd.append('sections_url', window.location.pathname);
      fetch(api('/cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (err) { err.textContent = res.body.description || res.body.message || 'This item could not be added.'; err.hidden = false; } return; }
          renderSections(res.body.sections);
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .finally(function () { atcs.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    });

    /* mobile sticky bar */
    var bar = root.querySelector('[data-fm-pdp-bar]');
    var mainBtn = form.querySelector('[data-fm-atc]');
    if (bar && mainBtn) {
      var shown = null, ticking = false;
      var checkBar = function () {
        ticking = false;
        var show = mainBtn.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkBar); } }, { passive: true });
      checkBar();
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fm-product]').forEach(initProduct);
    if (root && root.matches && root.matches('[data-fm-product]')) initProduct(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();